import { QueryItemContent } from '@discover-frontend/components';
import { ItemPic } from '@cubeyou-team/hx-react-components';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { getItemTypeToShow } from 'src/utils';

interface QueryEntityInfosProps {
  queryEntity: {
    type: string;
  };
  infos: {
    pic?: string;
    label?: string;
    source?: string;
    followers_count?: number;
    taxonomy?: string[] | null;
  };
}

const QueryEntityInfos: FC<QueryEntityInfosProps> = ({
  queryEntity,
  infos,
}) => {
  const dataSource = useSelector((state) => state.queryBuilder.dataSource);

  const taxonomy = Array.isArray(infos.taxonomy) ? infos.taxonomy : [];

  return (
    <QueryItemContent
      itemIcon={
        <ItemPic
          pic={infos.pic ?? ''}
          label={infos.label ?? ''}
          size="medium"
        />
      }
      label={infos.label ?? ''}
      source={infos.source ?? ''}
      selectedDataSource={dataSource}
      itemType={getItemTypeToShow(queryEntity.type)}
      followers_count={infos.followers_count}
      taxonomy={taxonomy}
      tooltipPosition="left"
      variant="small"
    />
  );
};

export default QueryEntityInfos;
